import { Card } from '@packages/ui/base/card/card';

export interface MatchCardProps {
  matchName: string;
}

export const MatchCard = ({ matchName }: MatchCardProps) => {
  return (
    <Card className="py-6">
      {/* ---- Header ---- */}
      <h2 className="mb-4 text-xl font-bold">Your match</h2>

      {/* ---- Match Name ---- */}
      <div className="bg-primary/6 ring-primary/30 relative overflow-hidden rounded-2xl px-4 py-5 text-center ring-1">
        <StaticConfetti />
        <p className="relative z-10 text-xl font-bold wrap-break-word">{matchName}</p>
      </div>
    </Card>
  );
};

interface ConfettiPiece {
  top: string;
  left: string;
  width: number;
  height: number;
  rotate: number;
  color: string;
  rounded?: boolean;
}

const CONFETTI: ConfettiPiece[] = [
  { top: '10%', left: '4%', width: 8, height: 4, rotate: 15, color: '#785ccf' },
  { top: '55%', left: '7%', width: 5, height: 5, rotate: 45, color: '#c084fc' },
  { top: '80%', left: '3%', width: 9, height: 3, rotate: -20, color: '#f0abfc' },
  { top: '25%', left: '14%', width: 5, height: 5, rotate: 60, color: '#e879f9', rounded: true },
  { top: '70%', left: '18%', width: 7, height: 3, rotate: 35, color: '#785ccf' },
  { top: '5%', left: '40%', width: 6, height: 3, rotate: -10, color: '#c084fc' },
  { top: '90%', left: '35%', width: 8, height: 4, rotate: 25, color: '#785ccf' },
  { top: '85%', left: '58%', width: 5, height: 5, rotate: 50, color: '#e879f9', rounded: true },
  { top: '8%', left: '70%', width: 7, height: 3, rotate: -30, color: '#f0abfc' },
  { top: '60%', left: '80%', width: 5, height: 5, rotate: 45, color: '#785ccf', rounded: true },
  { top: '20%', left: '88%', width: 9, height: 3, rotate: 10, color: '#c084fc' },
  { top: '75%', left: '93%', width: 6, height: 4, rotate: -45, color: '#e879f9' },
];

const StaticConfetti = () => (
  <div aria-hidden className="pointer-events-none absolute inset-0">
    {CONFETTI.map((p, i) => (
      <div
        // eslint-disable-next-line react/no-array-index-key -- This is a static confetti
        key={i}
        className="absolute opacity-70"
        style={{
          top: p.top,
          left: p.left,
          width: p.width,
          height: p.height,
          backgroundColor: p.color,
          transform: `rotate(${p.rotate}deg)`,
          borderRadius: p.rounded ? '50%' : 2,
        }}
      />
    ))}
  </div>
);
